module.exports = __webpack_public_path__ + "static/media/260-united-kingdom.c37683ab.png";